import angular from 'angular';
import gridHeight from '../../../app/core/shared-service/grid-utils';

class LadproviderGridController {
  /*@ngInject*/
  constructor(UtilSvc, $scope, uiGridConstants) {
    this.UtilSvc = UtilSvc;
    this.$scope = $scope;
    this.uiGridConstants = uiGridConstants;
  }

  $onInit() {
    let vm = this;
    vm.getGridHeight = getGridHeight;
    vm.gridOptions = {
      columnDefs: [
        {
          name: 'name',
          displayName: 'commons.name',
          headerCellFilter: 'translate',
          cellClass: 'pointer defaultcursor',
          sort: { direction: 'asc', priority: 0 },
          cellTemplate:
            '<a class="grid-cell-link" ui-sref="app.ladprovider.details({ guid: row.entity.id})"><div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div></a>'
        }
      ],
      exporterOlderExcelCompatibility: true,
      useExternalPagination: true,
      onRegisterApi: onRegisterApi,
      enableSorting: false,
      enableGridMenu: false,
      enableColumnMenus: false,
      enableVerticalScrollbar: vm.uiGridConstants.scrollbars.NEVER,
      paginationPageSizes: vm.gridParams.paginationPageSizes,
      paginationPageSize: vm.gridParams.paginationPageSize,
      data: vm.data
    };

    // Grille
    function onRegisterApi(gridApi) {
      vm.gridApi = gridApi;
    }

    function getGridHeight() {
      return gridHeight(vm.gridApi);
    }
  }
}

angular.module('app.ladprovider').component('ladproviderGrid', {
  templateUrl: require('./grid.html'),
  controller: LadproviderGridController,
  bindings: {
    gridParams: '=', // Critères de recherche de la grille
    data: '<' // Données à afficher dans la grille
  }
});
